<template>
    <div id="waiting-areas-data-table">
        <div v-if="alert.status" :class="getAlertClass()" role="alert">
            <i :class="getAlertIcon()"></i> {{ alert.message }}
        </div>
        <div class="row mb-3">
            <div class="col-12 col-md-6">
                <h6 class="font-weight-bold">Waiting Areas Management</h6>
            </div>
            <div class="col-12 col-md-6 text-md-right">
                <waiting-area-add @refreshData="refreshData"></waiting-area-add>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table table-bordered table-hover table-sm mb-0">
                <caption>List of Waiting Areas({{ waitingAreas.length }})</caption>
                <thead>
                    <tr>
                        <th scope="col">Waiting Area</th>
                        <th scope="col">Notes</th>
                        <th scope="col">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(waitingArea, i) in waitingAreas" :key="i">
                        <td>{{ waitingArea.waitingArea || "None" }}</td>
                        <td>{{ waitingArea.notes || "None" }}</td>
                        <td>
                            <waiting-area-edit :waitingArea="waitingArea" @refreshData="refreshData">
                            </waiting-area-edit>
                            <waitingArea-delete :waitingArea="waitingArea" @refreshData="refreshData"
                                @setAlert="setAlert">
                            </waitingArea-delete>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="waitingAreas.length == 0" class="alert alert-primary" role="alert">
                <i class="fas fa-bell"></i> There are currently no waiting areas. If you would like to add a
                waiting area, please click the 'add' button.
            </div>
        </div>
    </div>
</template>

<script>
import WaitingAreaAdd from './WaitingAreaAdd.vue';
import WaitingAreaDelete from './WaitingRoomDelete.vue';
import WaitingAreaEdit from './WaitingAreaEdit.vue';

export default {
    name: 'waiting-areas-data-table',
    components: {
        WaitingAreaAdd,
        WaitingAreaDelete,
        WaitingAreaEdit
    },
    props: {
        waitingAreas: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            alert: {
                message: '',
                status: false,
                type: ''
            }
        }
    },
    methods: {
        getAlertClass() {
            if (this.alert.type == "success") {
                return `alert alert-success`;
            } else if (this.alert.type == "warning") {
                return `alert alert-warning`;
            } else if (this.alert.type == "danger") {
                return `alert alert-danger`;
            }

            return `alert alert-primary`;
        },
        getAlertIcon() {
            if (this.alert.type == "success") {
                return `fas fa-check`;
            } else if (this.alert.type == "warning") {
                return `fas fa-exclamation-circle`;
            } else if (this.alert.type == "danger") {
                return `fas fa-exclamation-triangle`;
            }

            return `fas fa-bell`;
        },
        refreshData() {
            this.$emit('refreshData');
        },
        setAlert(message, status, type) {
            // Set alert
            this.alert = {
                message: message,
                status: status,
                type: type
            };

            // Set alert timeout
            setTimeout(() => {
                this.alert = {
                    message: '',
                    status: false,
                    type: ''
                }
            }, 5000);
        }
    }
}
</script>